import common from "./common.json";
import auth from "./auth.json";
import mfa from "./mfa.json";
import facilities from "./facilities.json";
import org from "./org.json";
import dashboard from "./dashboard.json";
import settings from "./settings.json";
import nav from "./nav.json";
import monitoringLocations from "./monitoringLocations.json";
import attachments from "./attachments.json";
import parameters from "./parameters.json";
import permits from "./permits.json";
import categoricalStandards from "./categoricalStandards.json";
import documents from "./documents.json";
import sampling from "./sampling.json";
import exceedances from "./exceedances.json";
import schedules from "./schedules.json";
import sampleResultDetail from "./sampleResultDetail.json";
import custody from "./custody.json";
import reroute from "./reroute.json";
import labsForEvent from "./labsForEvent.json";
import labs from "./labs.json";
import orgDefaults from "./orgDefaults.json";
import catalog from "./catalog.json";
import admin from "./admin.json";
import cccp from "./cccp.json";
import backflow_devices from "./backflow_devices.json";
import accounts from "./accounts.json";
import deviceInventory from "./device-inventory.json";
import installationActions from "./installation-actions.json";
import installations from "./installations.json";
import compliance from "./compliance.json";
import testers from "./testers.json";
import testingCompanies from "./testing-companies.json";
import fieldCredentials from "./field-credentials.json";
import fieldWork from "./field-work.json";
import formTemplates from "./form-templates.json";
import formRenderer from "./form-renderer.json";
import formUi from "./formUi.json";
import workAssignments from "./work-assignments.json";
import testCadence from "./test-cadence.json";
import customFields from "./custom-fields.json";
import formSubmissions from "./form-submissions.json";
import violations from "./violations.json";
import testKits from "./test-kits.json";
import company from "./company.json";
import customer from "./customer.json";
import notices from "./notices.json";
import tasks from "./tasks.json";
import userGroups from "./userGroups.json";
import testEntry from "./test-entry.json";
import recentPages from "./recentPages.json";
import messages from "./messages.json";
import reporting from "./reporting.json";
import notes from "./notes.json";
import vocabulary from "./vocabulary.json";
import changeRequests from "./change-requests.json";
import reportForms from "./report-forms.json";
import sams from "./sams.json";
import bulkEdits from "./bulkEdits.json";

export const en = {
  common,
  auth,
  mfa,
  facilities,
  org,
  dashboard,
  settings,
  nav,
  monitoringLocations,
  attachments,
  parameters,
  permits,
  categoricalStandards,
  documents,
  sampling,
  exceedances,
  schedules,
  sampleResultDetail,
  custody,
  reroute,
  labsForEvent,
  labs,
  orgDefaults,
  catalog,
  admin,
  cccp,
  backflow_devices,
  accounts,
  "device-inventory": deviceInventory,
  "installation-actions": installationActions,
  installations,
  compliance,
  testers,
  "testing-companies": testingCompanies,
  "field-credentials": fieldCredentials,
  "field-work": fieldWork,
  "form-templates": formTemplates,
  "form-renderer": formRenderer,
  formUi,
  "work-assignments": workAssignments,
  "test-cadence": testCadence,
  "custom-fields": customFields,
  "form-submissions": formSubmissions,
  violations,
  "test-kits": testKits,
  company,
  customer,
  notices,
  tasks,
  userGroups,
  recentPages,
  "test-entry": testEntry,
  messages,
  reporting,
  notes,
  vocabulary,
  "change-requests": changeRequests,
  "report-forms": reportForms,
  sams,
  bulkEdits,
} as const;
